import get from "lodash.get";

import { toSpecRequirementPayload } from "../../../../../actions/submittalActions";

export const APPROVAL_ERROR_MESSAGE = "The approval could not be saved";

export const getApprovalMessage = isApproved =>
  isApproved
    ? "The file has been approved successfully"
    : "The approval has been removed successfully";

export const updateSpecsByRequirement = (onUpdateSpec, specRequirements) => {
  const bySpecId = new Map();
  specRequirements.filter(Boolean).forEach(sr => {
    const specRequirement = toSpecRequirementPayload(sr);
    const specId = sr.specId || sr.spec?.id;
    bySpecId.set(specId, [...(bySpecId.get(specId) || []), specRequirement]);
  });

  return Promise.all(
    [...bySpecId].map(([id, requirements]) =>
      onUpdateSpec({ id, specRequirements: requirements })
    )
  );
};

export const uploadFileActions = ({
  selectedSpecRequirements,
  actions,
  onUpdateSpec,
  specRequirements,
  spec,
  newSubmittalFilesRef,
  uploadCount,
  setSubmittalFiles,
  submittalFiles,
  setLoaderActive,
  handleClear,
}) => {
  const getSubmittalFile = (uploadCount, submittalFiles) => {
    const uploadCountS3KeySet = new Set(
      newSubmittalFilesRef.current
        .filter(submittalFile => submittalFile.uploadCount == uploadCount)
        .map(({ file: { s3Key } }) => s3Key)
    );
    return submittalFiles.find(submittalFile =>
      uploadCountS3KeySet.has(submittalFile.file.s3Key)
    );
  };

  const handleUpload = async evt => {
    const file = evt.target.files[0];
    if (!file) return;

    setLoaderActive("upload");
    for await (const specRequirement of selectedSpecRequirements) {
      const newSubmittalFile = await actions.saveSpecSubmittal(
        {
          file: { file, isUpdated: true },
        },
        specRequirement,
        get(specRequirement, "spec", spec),
        onUpdateSpec,
        get(specRequirement, "spec", spec).specRequirements.findIndex(
          ({ id }) => id == specRequirement.id
        )
      );
      newSubmittalFilesRef.current.push({
        ...newSubmittalFile,
        specRequirement,
        uploadCount: uploadCount.current,
      });
    }
    uploadCount.current++;
    setSubmittalFiles([...submittalFiles, newSubmittalFilesRef.current.at(-1)]);
    handleClear();
  };

  const handleApprove = ({ uploadCount }) => async submittal => {
    const isApproved = !!submittal;
    setLoaderActive("approve");
    selectedSpecRequirements.forEach(specRequirement => {
      const { submittalFiles } = specRequirements.find(
        ({ id }) => id == specRequirement.id
      );
      const submittalFile = getSubmittalFile(uploadCount, submittalFiles);
      specRequirement.submittalApprovedId = isApproved
        ? submittalFile.id
        : null;
    });
    try {
      await updateSpecsByRequirement(onUpdateSpec, specRequirements);
      actions.showSnackNotificationAction(getApprovalMessage(isApproved));
    } catch (error) {
      actions.showSnackNotificationAction(APPROVAL_ERROR_MESSAGE);
    }
    handleClear();
  };

  const handleDelete = async ({ uploadCount }) => {
    selectedSpecRequirements.forEach(specRequirement => {
      const { submittalFiles } = specRequirements.find(
        ({ id }) => id == specRequirement.id
      );
      const submittalFile = getSubmittalFile(uploadCount, submittalFiles);
      specRequirement.submittalFiles = specRequirement.submittalFiles.filter(
        ({ id }) => id != submittalFile.id
      );
    });
    await updateSpecsByRequirement(onUpdateSpec, specRequirements);
    setSubmittalFiles(
      submittalFiles.filter(
        submittalFile => submittalFile.uploadCount != uploadCount
      )
    );
    handleClear();
  };

  return {
    handleUpload,
    handleApprove,
    handleDelete,
  };
};
